import { useQuery } from "@tanstack/react-query";
import { getAllAgents } from "../../api/apiAgents";

const QUERY_KEY = ["agents"];

const useGetAgents = (page = 1, perPage = 15, filters = {}) => {
  const {
    data,
    isLoading,
    isError,
    error,
    isFetching
  } = useQuery({
    queryKey: [...QUERY_KEY, page, perPage, filters],
    queryFn: () => getAllAgents(page, perPage, filters),
    keepPreviousData: true,
  });

  return {
    isLoading,
    isFetching,
    error: isError ? error : null,
    agents: data?.data?.items || data?.data || [],
    meta: data?.data?.meta || null,
  };
};

export default useGetAgents;
